import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { useState } from "react";

function ProjectCards(props) {
  const [showFullText, setShowFullText] = useState(false);
  const maxDisplayLength = 150;
  const truncatedString =
    (showFullText
      ? props.description
      : props.description.slice(0, maxDisplayLength)) +
    (props.description.length > maxDisplayLength ? "..." : "");

  const toggleShowFullText = () => {
    setShowFullText(!showFullText);
  };
  return (
    <div className="project-card-container">
      <Card className={`project-card-view ${showFullText ? "open" : ""}`}>
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        <Card.Body>
          <Card.Title>
            <h3 className="project-title">{props.title}</h3>
          </Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {truncatedString}
            {props.description.length > maxDisplayLength && (
              <a className="see-more" onClick={toggleShowFullText}>
                {showFullText ? <span>&#x25B2;</span> : "See More"}
              </a>
            )}
          </Card.Text>
          {props.ghLink ? (
            <Button variant="primary" href={props.ghLink} target="_blank">
              <BsGithub /> &nbsp;
              {props.isBlog ? "Blog" : "GitHub"}
            </Button>
          ) : null}
          {"\n"}
          {"\n"}

          {!props.isBlog && props.demoLink && (
            <Button
              variant="primary"
              href={props.demoLink}
              target="_blank"
              style={{ marginLeft: "10px" }}
            >
              <CgWebsite /> &nbsp;
              {"Demo"}
            </Button>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}
export default ProjectCards;
